import { NodeModel } from "../_model/NodeModel";
import { DecorationDecanter } from "../decanter/decorationDecanter";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Decanter extends NodeModel {
    constructor() {
        super("Decanter");

        this.type = new Types().Decanter;

        this.x = 0;
        this.y = 0;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 140;
        this.width = 140;
        this.operationSelected = '';
        this.srcImg = require("@/assets/Fluxogramas/decantador.png");
        this.data = [new Properties({...this })];
        this.CurrentTempAr = null
        this.jokerCaption = [];

        this.decorate = async function(callback) {
            this.decorator = new DecorationDecanter();
            await this.decorator.init(this, callback)
        };

        this.clone = () => {
            let cloned = new Decanter()

            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.decorator = null
            cloned.readOnly = this.readOnly
            cloned.expressionVisible = this.expressionVisible
            cloned.CurrentTempAr = this.CurrentTempAr
            cloned.data = this.data.map(d => d.clone());
            cloned.jokerCaption = this.jokerCaption
            
            return cloned
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.data = node.data.map(d => new Properties({...d }));
            this.CurrentTempAr = node.CurrentTempAr
            this.jokerCaption = node.jokerCaption
        }

        this.update = (node) => {
            if (node.attrs) {
                this.data = node.attrs;
            }

            if (node.CurrentTempAr) {
                this.CurrentTempAr = node.CurrentTempAr;
            }
            
            this.expressionVisible = node.expressionVisible;
            this.jokerCaption = node.jokerCaption;

        }

        // Para caso o nó tenha connections.
        // this.removeConnection = (connectionId) => {
        //   this.connectionPack = this.connectionPack.filter(connection => connection.conn.id != connectionId)
        // }
    }
}

export { Decanter };